import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Whatsapp,
  Facebook,
  Twitter,
  Linkedin,
} from '@icons-pack/react-simple-icons';

import { SPostSocials, SPostSocialBtn } from './styles';

const BlogSocialIcons = ({ title, href, isFooter = false }) => {
  const mainIconsRef = useRef(null);
  const [showStickyShare, setShowStickyShare] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', function () {
      const contentHeight =
        document.querySelector('.single-blog-post-content')?.scrollHeight || 0;
      const show = window.scrollY <= contentHeight;
      if (window.scrollY > 700 && show) {
        setShowStickyShare(true);
      } else {
        setShowStickyShare(false);
      }
    });
  }, [mainIconsRef.current]);

  let className = showStickyShare ? 'stick-start' : '';

  return (
    <SPostSocials ref={el => (mainIconsRef.current = el)} className={className}>
      {[
        {
          bg: '#0067b1',
          icon: <Linkedin color="#ffffff" />,
          name: 'LinkedIn',
          link: `https://www.linkedin.com/shareArticle?mini=true&url=${href}`,
        },
        {
          bg: '#306199',
          icon: <Facebook color="#ffffff" />,
          name: 'Facebook',
          link: `https://www.facebook.com/sharer/sharer.php?u=${href}`,
        },
        {
          bg: '#26c4f1',
          icon: <Twitter color="#ffffff" />,
          name: 'Twitter',
          link: `https://twitter.com/intent/tweet?url=${href}&text=${title}`,
        },
        {
          bg: '#2be833',
          icon: <Whatsapp color="#ffffff" />,
          name: 'Whatsapp',
          link: `https://wa.me?text=${href}`,
        },
      ].map(item => {
        return (
          <SPostSocialBtn
            href={item.link}
            target="_blank"
            key={item.name}
            bg={item.bg}
            className="share-icon"
          >
            {item.icon}
            <span className={'text'}>Share on {item.name}</span>
          </SPostSocialBtn>
        );
      })}
    </SPostSocials>
  );
};

BlogSocialIcons.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
  isFooter: PropTypes.bool,
};

export default BlogSocialIcons;
